var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.75C5 7.34375 5.3125 7 5.75 7H18.25C18.6562 7 19 7.34375 19 7.75C19 8.1875 18.6562 8.5 18.25 8.5H5.75C5.3125 8.5 5 8.1875 5 7.75ZM7 12.75C7 12.3438 7.3125 12 7.75 12H16.25C16.6562 12 17 12.3438 17 12.75C17 13.1875 16.6562 13.5 16.25 13.5H7.75C7.3125 13.5 7 13.1875 7 12.75ZM13.25 18.5H10.75C10.3125 18.5 10 18.1875 10 17.75C10 17.3438 10.3125 17 10.75 17H13.25C13.6562 17 14 17.3438 14 17.75C14 18.1875 13.6562 18.5 13.25 18.5Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.fa3547215c27f5fbff4cb84a91b6a902.svg";
export { ForwardRef as ReactComponent };